(function(){
var R=document.getElementById('iri');if(!R)return;
/* D.v: [id, tone, letter, available, img1100, img600, img160]; D.z: [id, sign, available] */
var D=window.IRI||{v:[],z:[],bp:0,zp:0,d:0,sel:null};
function $(id){return document.getElementById(id)}
function money(c){return '$'+(c/100).toFixed(2)}
var ZD={Aries:'Mar 21 – Apr 19',Taurus:'Apr 20 – May 20',Gemini:'May 21 – Jun 20',Cancer:'Jun 21 – Jul 22',Leo:'Jul 23 – Aug 22',Virgo:'Aug 23 – Sep 22',Libra:'Sep 23 – Oct 22',Scorpio:'Oct 23 – Nov 21',Sagittarius:'Nov 22 – Dec 21',Capricorn:'Dec 22 – Jan 19',Aquarius:'Jan 20 – Feb 18',Pisces:'Feb 19 – Mar 20'};
var ZO=['Aries','Taurus','Gemini','Cancer','Leo','Virgo','Libra','Scorpio','Sagittarius','Capricorn','Aquarius','Pisces'];
var form=$('iri-form'),btn=$('iri-btn'),msg=$('iri-msg'),grid=$('iri-letters'),chosen=$('iri-chosen'),tonel=$('iri-tonel'),silver=$('iri-silver'),hid=$('iri-id'),addW=$('iri-add'),addck=$('iri-addck'),zsel=$('iri-z'),err=$('iri-err');
var tiles=[].slice.call(grid.querySelectorAll('.lt')),toneBtns=[].slice.call(R.querySelectorAll('.tones button'));
var track=$('iri-track'),slides=[].slice.call(track.querySelectorAll('.slide')),thumbs=[].slice.call(document.querySelectorAll('#iri-thumbs button')),dotsW=$('iri-dots');
var s0=slides[0],s0img=s0.querySelector('img'),stag=s0.querySelector('.stag'),t0img=thumbs[0]&&thumbs[0].querySelector('img');
var def={src:s0img.getAttribute('src'),srcset:s0img.getAttribute('srcset')||'',alt:s0img.getAttribute('alt'),t:t0img?t0img.getAttribute('src'):''};
var vmap={},byId={},uses={};
D.v.forEach(function(v){vmap[v[1]+'|'+v[2]]=v;byId[v[0]]=v;uses[v[4]]=(uses[v[4]]||0)+1});
var tone='Gold',letter=null,cur=null,canBuy=D.v.length>0;
var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';

/* zodiac add-on */
var zm={};D.z.forEach(function(z){if(z[2])zm[z[1]]=z[0]});
ZO.forEach(function(n){if(!zm[n])return;var o=document.createElement('option');o.value=zm[n];o.textContent=n+' · '+ZD[n];zsel.appendChild(o)});
if(zsel.options.length<2){addW.style.display='none'}

/* gallery */
function vis(){return slides.filter(function(s){return!s.hidden})}
function idx(){var w=track.clientWidth||1;return Math.round(track.scrollLeft/w)}
function go(i,smooth){var vs=vis();if(!vs.length)return;i=(i+vs.length)%vs.length;track.scrollTo({left:vs[i].offsetLeft,behavior:smooth===false?'auto':'smooth'})}
function dots(){dotsW.innerHTML='';vis().forEach(function(){dotsW.appendChild(document.createElement('i'))});mark()}
function mark(){var i=idx(),vs=vis();slides.forEach(function(s,k){if(thumbs[k])thumbs[k].setAttribute('aria-current',vs[i]===s?'true':'false')});[].forEach.call(dotsW.children,function(d,k){d.className=k===i?'on':''})}
var tk=0;track.addEventListener('scroll',function(){if(tk)return;tk=requestAnimationFrame(function(){tk=0;mark()})},{passive:true});
R.querySelectorAll('.arr').forEach(function(a){a.addEventListener('click',function(){go(idx()+(+a.getAttribute('data-step')))})});
thumbs.forEach(function(t,k){t.addEventListener('click',function(){var i=vis().indexOf(slides[k]);if(i>-1)go(i)})});
function showAlt(on){slides.forEach(function(s,k){if(s.hasAttribute('data-alt')){s.hidden=!on;if(thumbs[k])thumbs[k].hidden=!on}})}
function gallery(user){
 var own=cur&&cur[1]==='Gold'&&cur[4]&&uses[cur[4]]===1;
 if(own){s0img.src=cur[4];s0img.srcset=cur[5]+' 600w, '+cur[4]+' 1100w';s0img.alt='Gold balloon initial necklace, letter '+cur[2];if(t0img)t0img.src=cur[6];stag.textContent='Shown: '+cur[2];stag.hidden=false}
 else{if(def.srcset)s0img.srcset=def.srcset;else s0img.removeAttribute('srcset');s0img.src=def.src;s0img.alt=def.alt;if(t0img)t0img.src=def.t;stag.hidden=true}
 showAlt(!!own);dots();if(user&&own)go(0,true);
}
dots();

/* tone + letter */
function paint(){
 toneBtns.forEach(function(b){b.setAttribute('aria-pressed',b.getAttribute('data-tone')===tone?'true':'false')});
 tonel.textContent=tone;silver.classList.toggle('on',tone==='Silver');
 tiles.forEach(function(t){var l=t.getAttribute('data-l'),v=vmap[tone+'|'+l];t.disabled=!(v&&v[3]);t.setAttribute('aria-pressed',l===letter?'true':'false')});
 chosen.innerHTML=cur?'<strong>'+cur[2]+'</strong> · '+tone:(letter?'Not available in '+tone.toLowerCase():'Choose one');
 hid.value=cur?cur[0]:'';
}
function pick(user){
 var v=letter?vmap[tone+'|'+letter]:null;cur=(v&&v[3])?v:null;
 if(!cur&&letter&&user===2){letter=null}
 paint();gallery(user);
 if(cur){grid.classList.remove('err');msg.classList.remove('on');try{var u=new URL(location.href);u.searchParams.set('variant',cur[0]);history.replaceState(history.state,'',u.toString())}catch(e){}}
 update();
}
toneBtns.forEach(function(b){b.addEventListener('click',function(){tone=b.getAttribute('data-tone');pick(2)})});
tiles.forEach(function(t){t.addEventListener('click',function(){if(t.disabled)return;letter=t.getAttribute('data-l');pick(1)})});

/* price + button */
function on(){return addck.checked&&addW.style.display!=='none'}
function total(){return on()?D.bp+D.zp-D.d:D.bp}
var stS=$('iri-stsign'),stP=$('iri-stprice'),stB=$('iri-stbtn');
function update(){
 addW.classList.toggle('on',on());
 btn.setAttribute('data-ready',(cur&&(!on()||zsel.value))?'1':'0');
 btn.innerHTML=on()?'Add the set – '+money(total())+' <s>'+money(D.bp+D.zp)+'</s>':'Add to bag – '+money(D.bp);
 stS.textContent=cur?('Initial '+cur[2]+' · '+tone+(on()?' + her sign':'')):'Balloon Initial Necklace';
 stP.textContent=money(total());stB.textContent=cur?(on()?'Add the set':'Add to bag'):'Choose her letter';
}
addck.addEventListener('change',update);
zsel.addEventListener('change',function(){zsel.classList.remove('err');update()});

function need(el,block){el.scrollIntoView({behavior:'smooth',block:block||'center'})}
function nolet(){grid.classList.add('err');msg.classList.add('on');need(grid)}
function add(){
 if(!canBuy){location.href=root+'collections/all';return}
 if(!cur){nolet();return}
 var items=[{id:cur[0],quantity:1}];
 if(on()){if(!zsel.value){zsel.classList.add('err');need(zsel);zsel.focus({preventScroll:true});return}items.push({id:+zsel.value,quantity:1})}
 if(btn.getAttribute('aria-busy')==='true')return;
 var old=btn.innerHTML;btn.setAttribute('aria-busy','true');btn.textContent='Adding…';err.classList.remove('on');
 fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:items})})
 .then(function(r){return r.json().then(function(j){if(!r.ok)throw j;return j})})
 .then(function(){location.href=root+'cart'})
 .catch(function(j){btn.removeAttribute('aria-busy');btn.innerHTML=old;err.textContent=(j&&j.description)||'Something went wrong. Please try again.';err.classList.add('on')});
}
form.addEventListener('submit',function(e){e.preventDefault();add()});
stB.addEventListener('click',function(){if(!cur){nolet();return}add()});
$('iri-setgo').addEventListener('click',function(){addck.checked=true;update();if(!cur){need(grid,'start');grid.classList.add('err');msg.classList.add('on')}else{need(addW)}});

/* sticky bar */
var st=$('iri-stick');
if(st&&window.IntersectionObserver){new IntersectionObserver(function(es){var e=es[0];st.classList.toggle('on',!e.isIntersecting&&e.boundingClientRect.top<0)}).observe(btn)}

/* reveal */
if(window.IntersectionObserver){var io=new IntersectionObserver(function(es){es.forEach(function(x){if(x.isIntersecting){x.target.classList.add('in');io.unobserve(x.target)}})},{rootMargin:'0px 0px -8% 0px'});R.querySelectorAll('.rv').forEach(function(el){io.observe(el)})}else{R.querySelectorAll('.rv').forEach(function(el){el.classList.add('in')})}

/* initial state (variant in URL) */
if(D.sel&&byId[D.sel]){var sv=byId[D.sel];tone=sv[1];letter=sv[2];pick(0)}else{paint();update()}
})();
